import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../../assets/AuthContext';

// Feather-style SVG icons
const Icons = {
  dashboard: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/>
      <rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/>
    </svg>
  ),
  projects: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 19a2 2 0 01-2 2H4a2 2 0 01-2-2V5a2 2 0 012-2h5l2 3h9a2 2 0 012 2z"/>
    </svg>
  ),
  data: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <ellipse cx="12" cy="5" rx="9" ry="3"/>
      <path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3"/>
      <path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5"/>
    </svg>
  ),
  settings: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="3"/>
      <path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83-2.83l.06-.06A1.65 1.65 0 004.68 15a1.65 1.65 0 00-1.51-1H3a2 2 0 010-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 012.83-2.83l.06.06A1.65 1.65 0 009 4.68a1.65 1.65 0 001-1.51V3a2 2 0 014 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 2.83l-.06.06A1.65 1.65 0 0019.4 9a1.65 1.65 0 001.51 1H21a2 2 0 010 4h-.09a1.65 1.65 0 00-1.51 1z"/>
    </svg>
  ),
  users: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/>
      <circle cx="9" cy="7" r="4"/>
      <path d="M23 21v-2a4 4 0 00-3-3.87"/>
      <path d="M16 3.13a4 4 0 010 7.75"/>
    </svg>
  ),
  collapse: (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="15 18 9 12 15 6"/>
    </svg>
  ),
  expand: (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="9 18 15 12 9 6"/>
    </svg>
  ),
};

const NAV_ITEMS = [
  { path: '/', label: 'Dashboard', icon: Icons.dashboard },
  { path: '/projects', label: 'Projects', icon: Icons.projects },
  { path: '/data', label: 'Data Manager', icon: Icons.data, adminOnly: true },
  { path: '/settings', label: 'Settings', icon: Icons.settings },
  { path: '/users', label: 'Users', icon: Icons.users, adminOnly: true },
];

export default function Sidebar({ collapsed, setCollapsed }) {
  const { user } = useAuth();
  const W = collapsed ? 56 : 220;

  return (
    <div
      className="dg-sidebar"
      style={{
        width: W, minWidth: W, maxWidth: W,
        height: '100vh',
        display: 'flex', flexDirection: 'column',
        transition: 'width 0.25s ease',
        overflow: 'hidden',
        position: 'fixed', top: 0, left: 0, zIndex: 100,
      }}
    >
      {/* Logo row */}
      <div style={{
        padding: collapsed ? '16px 0' : '0 16px',
        borderBottom: '1px solid var(--glass-border)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: collapsed ? 'center' : 'space-between',
        minHeight: 64,
        gap: 10,
        flexShrink: 0,
      }}>
        {!collapsed && (
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, overflow: 'hidden' }}>
            <img src="/logo.png" alt="Tsela" style={{ width: 32, height: 32, objectFit: 'contain', flexShrink: 0 }} />
            <div style={{ whiteSpace: 'nowrap' }}>
              <div style={{ color: 'var(--text-primary)', fontWeight: 800, fontSize: 13, letterSpacing: '0.04em' }}>
                Tse<span style={{ color: '#C6A744' }}>la</span>
              </div>
              <div style={{ color: 'var(--text-tertiary)', fontSize: 9, letterSpacing: '0.1em', textTransform: 'uppercase' }}>
                Obstacle Safeguarding
              </div>
            </div>
          </div>
        )}
        {collapsed && (
          <img src="/logo.png" alt="T" style={{ width: 28, height: 28, objectFit: 'contain' }} />
        )}

        {!collapsed && (
          <button
            onClick={() => setCollapsed(true)}
            style={{
              background: 'var(--glass-fill)',
              border: '1px solid var(--glass-border)',
              color: 'var(--text-tertiary)',
              padding: '5px',
              cursor: 'pointer',
              borderRadius: 8,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'all 0.2s',
              flexShrink: 0,
            }}
            title="Collapse Sidebar"
          >
            {Icons.collapse}
          </button>
        )}
      </div>

      {/* Expand button when collapsed */}
      {collapsed && (
        <div style={{ display: 'flex', justifyContent: 'center', padding: '8px 0', flexShrink: 0 }}>
          <button
            onClick={() => setCollapsed(false)}
            style={{
              background: 'var(--glass-fill)',
              border: '1px solid var(--glass-border)',
              color: 'var(--text-tertiary)',
              padding: '5px',
              cursor: 'pointer',
              borderRadius: 8,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'all 0.2s',
            }}
            title="Expand Sidebar"
          >
            {Icons.expand}
          </button>
        </div>
      )}

      {/* Nav items */}
      <nav style={{ flex: 1, padding: '8px 0', overflowY: 'auto' }}>
        {NAV_ITEMS.filter(item => !item.adminOnly || user?.role === 'admin').map(item => (
          <NavLink
            key={item.path}
            to={item.path}
            end={item.path === '/'}
            className={({ isActive }) => `dg-nav-link${isActive ? ' active' : ''}`}
            style={({ isActive }) => ({
              display: 'flex',
              alignItems: 'center',
              justifyContent: collapsed ? 'center' : 'flex-start',
              gap: collapsed ? 0 : 12,
              padding: collapsed ? '11px 0' : '10px 14px',
              margin: collapsed ? '2px 8px' : '2px 8px',
              textDecoration: 'none',
              color: isActive ? 'var(--text-primary)' : 'var(--text-secondary)',
              fontSize: 13,
              fontWeight: isActive ? 500 : 400,
            })}
          >
            <span style={{
              flexShrink: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: collapsed ? 22 : 'auto',
            }}>
              {item.icon}
            </span>
            {!collapsed && <span>{item.label}</span>}
          </NavLink>
        ))}
      </nav>

      {/* Version */}
      <div style={{
        padding: '12px',
        borderTop: '1px solid var(--glass-border)',
        fontSize: 10,
        color: 'var(--text-tertiary)',
        textAlign: 'center',
        flexShrink: 0,
        letterSpacing: '0.06em',
      }}>
        {collapsed ? 'v2' : 'v2.5.0 · Quantum'}
      </div>
    </div>
  );
}
